// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"210":"Kyc","478":"end","561":"orderFail","692":"NoKycAward","729":"KycAward","962":"home","998":"orderSuccess"}[chunkId] + "." + {"210":"57e367f2","478":"2db868d7","561":"a9bc8997","692":"f1d4defb","729":"d3d6d2d2","962":"80b61fa2","998":"e0a34f17"}[chunkId] + ".css";
};